import React from 'react';
import Grid from '@material-ui/core/Grid';

import Score from './Score';
import Team from './Team';
import Clock from '@/components/Clock';


function Scoreboard({ clock, period, teams, stats }) {
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid container item alignItems="center" xs={4}>
        <Grid container item xs={6} lg justify="center">
          <Team visitor team={teams[teams.visitor]} />
        </Grid>
        <Grid item xs={6} lg={2}>
          <Score score={stats[teams.visitor].goals.total} />
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Clock elapsed={clock.elapsed} total={clock.total} period={period} />
      </Grid>
      <Grid container item alignItems="center" xs={4}>
        <Grid item xs={6} lg={2}>
          <Score score={stats[teams.home].goals.total} />
        </Grid>
        <Grid container item xs={6} lg justify="center">
          <Team team={teams[teams.home]} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Scoreboard;
